module.exports = __webpack_public_path__ + "media/images/search-material-f9c7ec56f36102b5bf39bdbd0eda47e8.svg";